import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-offered-reward-card-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './offered-reward-card-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./offered-reward-card-skeleton.component.scss'],
})
export class OfferedRewardCardSkeletonComponent {}
